import { Component, OnInit } from '@angular/core';
import { UserModel } from 'src/app/models/user.model';
import { UserService } from 'src/app/services/user.service';
import { Location } from '@angular/common';

@Component({
  standalone: false,
  selector: 'app-privacypolicy',
  templateUrl: './privacypolicy.component.html',
  styleUrls: ['./privacypolicy.component.css']
})
export class PrivacypolicyComponent implements OnInit {
  user:UserModel;
  constructor(private userService:UserService,private location: Location) { }

  ngOnInit() {
    this.getUserPrivacyPolicy();
  }

  getUserPrivacyPolicy() {
    this.userService.cast.subscribe((userData: UserModel) => {
      if (userData !== undefined) {
        this.user = userData;
      }
    });
  }

  savePrivacyPolicy() {
    this.userService.updateUserPrivacyPolicyFlag(this.user).subscribe(resp => {
      location.reload();
    });
  }

}
